import { authGuard } from './core/authentication';
import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { MobilelayoutComponent } from './pages/mobile/layout/mobilelayout/mobilelayout.component';

export const appRoutes: VexRoutes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/pages/auth/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'mobilelogin',
    loadComponent: () => import('./pages/mobile/mobilelogin/mobilelogin.component').then((m) => m.MobileloginComponent)
  },
  {
    path: 'mobile',
    component: MobilelayoutComponent,
    // canActivate: [authGuard],
    // canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/mobile/layout/apps/apps.component').then((m) => m.AppsComponent)
      },
      {
        path: 'ledger',
        loadComponent: () => import('./pages/displayreport/ledger/ledger.component').then((m) => m.LedgerComponent)
      },
      {
        path: 'outstanding',
        loadComponent: () => import('./pages/displayreport/outstanding/outstanding.component').then((m) => m.OutstandingComponent)
      },
      {
        path: 'stock',
        loadComponent: () => import('./pages/stockreport/groupsummary/groupsummary.component').then((m) => m.GroupsummaryComponent)
      },

      {
        path: 'attendance',
        loadComponent: () => import('./pages/mobile/component/attendance/attendance.component').then((m) => m.AttendanceComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/mobile/component/profile/profile.component').then((m) => m.ProfileComponent)
      }
    ]
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/pages/auth/register/register.component').then((m) => m.RegisterComponent)
  },
  {
    path: 'companyselect',
    loadComponent: () => import('./pages/companyinfo/companyselect/companyselect.component').then((m) => m.CompanyselectComponent)
  },
  {
    path: 'companyalt',
    loadComponent: () => import('./pages/companyinfo/companyinfo.component').then((m) => m.CompanyinfoComponent),
    data: {
      scrollDisabled: true,
      toolbarShadowEnabled: false
    }
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/pages/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'coming-soon',
    loadComponent: () => import('./pages/pages/coming-soon/coming-soon.component').then((m) => m.ComingSoonComponent)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: '',
        loadComponent: () => import('./pages/dashboards/dashboard-analytics/dashboard-analytics.component').then((m) => m.DashboardAnalyticsComponent)
      },
      {
        path: 'company',
        loadComponent: () => import('./pages/companyinfo/companyinfo.component').then((m) => m.CompanyinfoComponent),
        data: {
          scrollDisabled: true,
          toolbarShadowEnabled: false
        }
      },

      {
        path: 'Master',
        children: [
          {
            path: 'account',
            loadChildren: () => import('./pages/Master/account/account.routes')
          },
          {
            path: 'inventory',
            loadChildren: () => import('./pages/Master/inventery/inventery.routes')
          }
        ]
      },
      {
        path: 'transaction',
        children: [
          {
            path: 'salesorder',
            loadComponent: () => import('./pages/transaction/salesorder/salesorder.component').then((m) => m.SalesorderComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'voucher',
            loadComponent: () => import('./pages/transaction/voucher/voucher.component').then((m) => m.VoucherComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'production',
            loadComponent: () => import('./pages/transaction/production/production.component').then((m) => m.ProductionComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'sales',
            loadComponent: () => import('./pages/transaction/sales/sales.component').then((m) => m.SalesComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },

          {
            path: 'saleschalan',
            loadComponent: () => import('./pages/transaction/saleschalan/saleschalan.component').then((m) => m.SaleschalanComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'creditnot',
            loadComponent: () => import('./pages/transaction/creditnote/creditnote.component').then((m) => m.CreditnoteComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'purchase',
            loadComponent: () => import('./pages/transaction/purchase/purchase.component').then((m) => m.PurchaseComponent),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'inventory',
            loadChildren: () => import('./pages/transaction/inventory/inventory.routes')
          },
          {
            path: 'exctargetent',
            loadComponent: () => import('./pages/transaction/executivetargetent/executivetargetent.component').then((m) => m.ExecutivetargetentComponent),
            data: {
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: 'displayreport',
        children: [
          {
            path: 'ledger',
            loadComponent: () => import('./pages/displayreport/ledger/ledger.component').then((m) => m.LedgerComponent),
            data: {
              reuse: false,
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'daybook',
            loadComponent: () => import('./pages/displayreport/daybook/daybook.component').then((m) => m.DaybookComponent),
            data: {
              reuse: false,
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'outstanding',
            loadComponent: () => import('./pages/displayreport/outstanding/outstanding.component').then((m) => m.OutstandingComponent),
            data: {
              reuse: false,
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'daywiseoutstanding',
            loadComponent: () => import('./pages/displayreport/daywiseoutstanding/daywiseoutstanding.component').then((m) => m.DaywiseoutstandingComponent),
            data: {
              reuse: false,
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: 'misreport',
        children: [
          {
            path: 'exctragetachiv',
            loadComponent: () => import('./pages/misreports/exctragetachiv/exctragetachiv.component').then((m) => m.ExctragetachivComponent),
            data: {
              reuse: false,
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'inactiveacc',
            loadComponent: () => import('./pages/misreports/inactiveacc/inactiveacc.component').then((m) => m.InactiveaccComponent),
            data: {
              reuse: false,
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: 'stockreport',
        children: [
          {
            path: 'stockitem',
            loadComponent: () => import('./pages/stockreport/stockitem/stockitem.component').then((m) => m.StockitemComponent),
            data: {
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'groupsummary',
            loadComponent: () => import('./pages/stockreport/groupsummary/groupsummary.component').then((m) => m.GroupsummaryComponent),
            data: {
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'productionlist',
            loadComponent: () => import('./pages/stockreport/productionlist/productionlist.component').then((m) => m.ProductionlistComponent),
            data: {
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: 'reportregister',
        loadChildren: () => import('./pages/reportregister/reportregister.routes')
      },
      {
        path: 'billsundryconfig',
        loadComponent: () => import('./pages/configuration/billsundryconfig/billsundryconfig.component').then((m) => m.BillsundryconfigComponent)
      },
      {
        path: 'webuser',
        children: [
          {
            path: 'usermanage',
            loadComponent: () => import('./pages/pages/auth/webuser/webuser.component').then((m) => m.WebuserComponent),
            data: {
              scrollDisabled: true,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'useraccess',
            loadComponent: () => import('./pages/utilities/useraccess/useraccess.component').then((m) => m.UseraccessComponent),
            data: {
              scrollDisabled: false,
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: '',
        children: [
          {
            path: 'configuration',
            loadComponent: () => import('./pages/configuration/generalconfiguration/generalconfiguration.component').then((m) => m.GeneralconfigurationComponent),
            data: {
              scrollDisabled: false,
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: 'apps',
        children: [
          {
            path: 'chat',
            loadChildren: () => import('./pages/apps/chat/chat.routes')
          },

          {
            path: 'mail',
            loadChildren: () => import('./pages/apps/mail/mail.routes'),
            data: {
              toolbarShadowEnabled: true,
              scrollDisabled: true
            }
          },
          {
            path: 'social',
            loadChildren: () => import('./pages/apps/social/social.routes')
          },
          {
            path: 'contacts',
            loadChildren: () => import('./pages/apps/contacts/contacts.routes')
          },
          {
            path: 'calendar',
            loadComponent: () => import('./pages/apps/calendar/calendar.component').then((m) => m.CalendarComponent),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'aio-table',
            loadComponent: () => import('./pages/apps/aio-table/aio-table.component').then((m) => m.AioTableComponent),
            data: {
              reuse: false,
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'help-center',
            loadChildren: () => import('./pages/apps/help-center/help-center.routes')
          },
          {
            path: 'scrumboard',
            loadChildren: () => import('./pages/apps/scrumboard/scrumboard.routes')
          },
          {
            path: 'editor',
            loadComponent: () => import('./pages/apps/editor/editor.component').then((m) => m.EditorComponent),
            data: {
              scrollDisabled: true
            }
          }
        ]
      },
      {
        path: 'pages',
        children: [
          {
            path: 'pricing',
            loadComponent: () => import('./pages/pages/pricing/pricing.component').then((m) => m.PricingComponent)
          },
          {
            path: 'faq',
            loadComponent: () => import('./pages/pages/faq/faq.component').then((m) => m.FaqComponent)
          },
          {
            path: 'guides',
            loadComponent: () => import('./pages/pages/guides/guides.component').then((m) => m.GuidesComponent)
          },
          {
            path: 'invoice',
            loadComponent: () => import('./pages/pages/invoice/invoice.component').then((m) => m.InvoiceComponent)
          },
          {
            path: 'error-404',
            loadComponent: () => import('./pages/pages/errors/error-404/error-404.component').then((m) => m.Error404Component)
          },
          {
            path: 'error-500',
            loadComponent: () => import('./pages/pages/errors/error-500/error-500.component').then((m) => m.Error500Component)
          }
        ]
      },
      {
        path: 'ui',
        children: [
          {
            path: 'components',
            loadChildren: () => import('./pages/ui/components/components.routes')
          },
          {
            path: 'forms/form-elements',
            loadComponent: () => import('./pages/ui/forms/form-elements/form-elements.component').then((m) => m.FormElementsComponent)
          },
          {
            path: 'forms/form-wizard',
            loadComponent: () => import('./pages/ui/forms/form-wizard/form-wizard.component').then((m) => m.FormWizardComponent)
          },
          {
            path: 'icons',
            loadChildren: () => import('./pages/ui/icons/icons.routes')
          },
          {
            path: 'page-layouts',
            loadChildren: () => import('./pages/ui/page-layouts/page-layouts.routes')
          }
        ]
      },
      {
        path: 'documentation',
        loadChildren: () => import('./pages/documentation/documentation.routes')
      },
      {
        path: '**',
        loadComponent: () => import('./pages/pages/errors/error-404/error-404.component').then((m) => m.Error404Component)
      }
    ]
  }
];
